<ngx-ui-loader></ngx-ui-loader>
<div id="denyDashboardAccess" class="background">
<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <h5>Report</h5>

    <div class="col-md-12">
      <mat-card>
          <mat-card-content>
              <div class="row align-items-end" style="padding: 10px; display: flex; flex-wrap: wrap; gap: 16px 0;">
                <div class="col-md-2">
                  <ng-select [items]="transformerIds" 
                    placeholder="Transformer" [(ngModel)]="idFilter"
                    (change)="filters('transformerId',idFilter)" [clearable]="false">
                  </ng-select>
                </div>
                <div class="col-md-2">
                  <mat-form-field class="form-element w-100">
                    <mat-label>Duration</mat-label>
                    <mat-select [(value)]="timeFilter">
                      <mat-option *ngFor="let time of timeOptions" [value]="time" (click)='filters("date",time)'>
                        {{time}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-2">
                  <mat-form-field class="form-element w-100">
                    <mat-label>Filter Paramter</mat-label>
                    <mat-select [(ngModel)]="selectedParameterStatus" >
                      <mat-option *ngFor="let status of parameterList" [value]="status">
                        {{status.internal}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-2">
                  <mat-form-field class="form-element w-100">
                    <mat-label>Filter Threshold Value</mat-label>
                   <input matInput type="text" [(ngModel)]="thresholdInputValue" placeholder="Oil-Level Low=4 Medium=5 Large=6" (input)="onThresholdInputChange()">
                  </mat-form-field>
                </div>
                <div class="col-md-2">
                  <mat-form-field class="form-element w-100">
                    <mat-label>Params</mat-label>
                    <mat-select [ngModel]="parametersOption">
                      <mat-option *ngFor="let param of parametersOption" [value]="parametersOption" (click)='filters("parameters",param)'>
                        {{param}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-2 d-flex align-items-center">
                  <button (click)="DailyConsumptionReport()" class="btn btn-primary w-100">Consumption Report <i class="fa fa-download"></i></button>
                </div>
              </div>
              <div class="row">
                <p style="margin-left: 2%;"><b>Download In:</b></p>
                <div>
                  <button style="margin-left: 2%;"  mat-button (click)="downloadExcel('excel')"><img src="../../assets/images/icons8-microsoft-excel-30.png">
                  </button>
                
                  <button  *ngIf="currentUserData.userid == 387" style="margin-left: 2%;" class="btn btn-primary" (click)="downloadloraReport()">Lora Device Report
                                    </button>
                </div>
                
                <div *ngIf="isDownloading" class="download-loader">
                  <div class="download-animation">
                    <svg class="download-cloud" viewBox="0 0 64 64">
                      <path d="M48,24c0-8.8-7.2-16-16-16S16,15.2,16,24c-5.3,0-10,4.3-10,10s4.7,10,10,10h32c5.3,0,10-4.3,10-10S53.3,24,48,24z"
                            fill="#ddd"/>
                      <g class="arrow">
                        <line x1="32" y1="28" x2="32" y2="44" stroke="#00f0ff" stroke-width="4" stroke-linecap="round"/>
                        <polyline points="24,36 32,44 40,36" fill="none" stroke="#00f0ff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </svg>
                  </div>
                  <mat-progress-spinner mode="indeterminate" diameter="24" color="accent"></mat-progress-spinner>
                  <p class="download-text">{{downloadMessage}}<strong>{{ remainingTime }}</strong>s left</p>
                </div>
                <p></p>
                <div>
                  <!--<button  mat-button  (click)="refreshData()"><b>Refresh: </b><img style="margin-left: 2%;" src="../../assets/images/icons8-refresh-30.png"></button>
                  --></div>
               
                <div style="margin-left: 4%;" *ngIf="currentUserData.userid == 292">
                  <button class="btn btn-success" (click)="fileInput.click()">Upload Folder <i class="fa fa-upload"></i></button>
                      <input #fileInput type="file" (change)="onFolderSelect($event)" style="display: none;" webkitdirectory directory multiple />
                  <div *ngIf="isUploading" style="text-align: center; margin: 20px;">
                    <p>Uploading...</p>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  </div>
                </div>
                <div *ngIf="currentUserData.userid == 292" style="margin-left: 1%;"> 
                  <button
                    class="btn btn-info"
                    (click)="getUploadData()"
                    *ngIf="!isDownloading"
                  >
                  Get Data <i class="fa fa-download"></i>
                  </button>
                  <span *ngIf="isDownloading" class="loaderanimation"></span>
                </div>
                <div *ngIf="isTapPosition">
                  Tap Position Counter : <b>{{tapCounter}}</b>
                </div>
              </div>
          </mat-card-content>
      </mat-card>
  </div>

    <!-- <div class="col-md-12">

        <mat-form-field class="form-element" style="margin-left:2%">
            <mat-label>Transformer Id</mat-label>
            <mat-select   [ngModel]="transformerId">
                <mat-option  *ngFor="let id of transformerId"  [value]="transformerId" (click)='filters("transformerId",id)'>
                    {{id}}
                  </mat-option>
              </mat-select>
        </mat-form-field>

        <mat-form-field class="form-element" style="margin-left:2%">
          <mat-label>Time</mat-label>
          <mat-select   [ngModel]="timeOptions">
              <mat-option  *ngFor="let time of timeOptions" [value]="time"  (click)='filters("date",time)'>
                  {{time}}
                </mat-option>
            </mat-select>
      </mat-form-field>

      <mat-form-field class="form-element" style="margin-left:2%" >
        <mat-label>Params</mat-label>
        <mat-select   [ngModel]="parametersOption">
            <mat-option  *ngFor="let param of parametersOption" [value]="parametersOption"  (click)='filters("parameters",param)'>
                {{param}}
              </mat-option>
          </mat-select>
    </mat-form-field>

      <button style="margin-left: 2%;" class="mat-raised-button mat-primary" mat-button (click)="exporter.exportTable('xlsx',{fileName:'SmartReport'})">Export to Excel<span class="material-icons">
        get_app
        </span></button>


      <button style="margin-left: 2%;" class="mat-raised-button mat-primary" btn-primary mat-button  (click)="exportToPdf()">Export to PDF <span class="material-icons">
        get_app
        </span></button>



      <button style="margin-left: 2%;" class="mat-raised-button mat-primary" btn-primary mat-button  (click)="refreshData()"> <span class="material-icons">
        refresh
        </span></button>


    </div> -->
    <div class="row col-md-12" style="margin-top: 2%;">
        <div class="col-md-12">
          <div >
            <table  mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" matSort class="example-container mat-elevation-z8" >
                <div *ngFor="let col of reportColumns">
              <ng-container   [matColumnDef]="col">
                <div *ngIf="col">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style=" background-color:wheat; color: black;"> {{getHeaderName(col)}} </th>
                </div>
                  <div *ngIf="col && currentUserData.userid != 272; else indiaPower">
                    <td mat-cell *matCellDef="let element"
                          [ngStyle]="{
                            'color':
                              (element[col] === 'Healthy' &&
                                (col === 'PRV_Status' ||
                                 col === 'OSR_Status' ||
                                 col === 'Buchholz_Status' ||
                                 col === 'OTI_Status' ||
                                 col === 'WTI_Status' ||
                                 col === 'Aircell_Relay' || col === 'OTI_Alarm_Status' || col === 'WTI_Alarm_Status' ||col === 'OTI_Trip_Status' ||
                                 col === 'WTI_Trip_Status' ||
                                 col === 'MOG_Status')) ? 'green' :

                              (element[col] === 'Operated' &&
                                (col === 'PRV_Status' ||
                                 col === 'OSR_Status' ||
                                 col === 'Buchholz_Status' ||
                                 col === 'OTI_Status' ||
                                 col === 'WTI_Status' ||
                                 col === 'Aircell_Relay' || col === 'OTI_Alarm_Status' || col === 'WTI_Alarm_Status' ||col === 'OTI_Trip_Status' ||
                                 col === 'WTI_Trip_Status' ||
                                 col === 'MOG_Status')) ? 'red' :

                              col === 'lugtempr' || col === 'R_Ph_N' || col === 'L1' ||
                              col === 'R_Power_Factor' || col === 'R_Active_Power' ||
                              col === 'R_Reactive_Power' || col === 'R_apparent_Power' ? 'red' :

                              col === 'lugtempy' || col === 'Y_Ph_N' || col === 'L2' ||
                              col === 'Y_Power_Factor' || col === 'Y_Active_Power' ||
                              col === 'Y_Reactive_Power' || col === 'Y_apparent_Power' ? '#B07D07' :

                              col === 'lugtempb' || col === 'B_Ph_N' || col === 'L3' ||
                              col === 'B_Power_Factor' || col === 'B_Active_Power' ||
                              col === 'B_Reactive_Power' || col === 'B_apparent_Power' ? 'blue' : ''
                          }">
                          {{ element[col] }}
                        </td>
                  </div>
                  <ng-template #indiaPower>
                    <div *ngIf="col">
                      <td mat-cell *matCellDef="let element" [ngStyle]="{color: col == 'Oil_Temperature' && element[col] > thresholdValues[4].parameterValue? 'red':col == 'Avg_Power_Factor' && element[col] < thresholdValues[8].parameterValue? 'red':col == 'loadPercentage' && element[col] > thresholdValues[0].parameterValue? 'red':col == 'loadPercentage' && element[col] < thresholdValues[1].parameterValue? 'red':col == 'Average_Voltage' && element[col] > thresholdValues[2].parameterValue? 'red':col == 'Average_Voltage' && element[col] < thresholdValues[3].parameterValue? 'red': (col == 'Winding_Temp_By_Cal' || col == 'Winding_Temperature') && element[col] > thresholdValues[5].parameterValue? 'red':col == 'loadPercentage' && element[col] > thresholdValues[15].parameterValue? 'red':''}"> {{element[col]}} </td>
                  </div>
                  </ng-template>
                </ng-container>
              </div>
                <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
              </table>
              <mat-paginator
              [length]="totalRecords"
              [pageSize]="5"
              [pageSizeOptions]="[5]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </div>
    </div>
    <div class="no-data-wrapper" *ngIf="dataSource?.length === 0">
  <div class="no-data-box">
    <p>No data available</p>
  </div>
</div>
    </div>
    
</div>